export default "__VITE_ASSET__JvV8cybI__"